<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Sélection des consultations </div>
        <div class="modal-body">
            <div class="search">
                <frg-search-input (search)="onSearchCritere($event)"></frg-search-input>
            </div>
            <div class="table">
                <frg-table #table3 [keysBody]="consultBodyTable" [keysColumn]="consultColumnTable"
                    [isRowsClickable]="true" (onClickRow)="addRemoveFactor($event)">
                </frg-table>
            </div>
            <form [formGroup]="visualForm" (ngSubmit)="sendVisuals()" *ngIf="visualForm" class="checks-container">
                <p>Quelle partie des consultations voulez-vous sélectionner ?</p>
                <div class="check-line">
                    <frg-form-input label="Toute la consultation" id="isAll" type="checkbox" [formGroup]="visualForm"
                        [control]="visualForm.get('isAll')" [isCheckLabelAlign]="true" class="input">
                    </frg-form-input>
                    <frg-form-input label="Le diagnostic en saisie libre" id="isDiagnosticTexte" type="checkbox"
                        [formGroup]="visualForm" [control]="visualForm.get('isDiagnosticTexte')"
                        [isCheckLabelAlign]="true" class="input">
                    </frg-form-input>
                </div>
                <div class="check-line">
                    <frg-form-input label="Le diagnostic en saisie guidée" id="isDiagnosticGuide" type="checkbox"
                        [formGroup]="visualForm" [control]="visualForm.get('isDiagnosticGuide')"
                        [isCheckLabelAlign]="true" class="input">
                    </frg-form-input>
                    <frg-form-input label="Les ordonnance" id="isOrdonnance" type="checkbox" [formGroup]="visualForm"
                        [control]="visualForm.get('isOrdonnance')" [isCheckLabelAlign]="true" class="input">
                    </frg-form-input>
                </div>
                <div class="check-line">
                    <frg-form-input label="Les courriers" id="isCourrier" type="checkbox" [formGroup]="visualForm"
                        [control]="visualForm.get('isCourrier')" [isCheckLabelAlign]="true" class="input">
                    </frg-form-input>
                    <frg-form-input label="L'imagerie" id="isImagerie" type="checkbox" [formGroup]="visualForm"
                        [control]="visualForm.get('isImagerie')" [isCheckLabelAlign]="true" class="input">
                    </frg-form-input>
                </div>
            </form>
            <div class="button-wrapper">
                <frg-button (activated)="closeAddEditModal()" [backgroundColor]="'var(--darkest-primary)'"
                    [type]="'reset'">
                    Quitter</frg-button>
                <frg-button [backgroundColor]="'var(--primary)'" [type]="'submit'" (click)="sendVisuals()">Valider
                </frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>